/**
 * Constants representing different shop categories
 */
export const SHOP_CATEGORIES = {
    /** Barbershop category */
    BARBERSHOP: 'BARBERSHOP',
    /** Hair salon category */
    HAIR_SALON: 'HAIR_SALON',
    /** Beauty salon category */
    BEAUTY_SALON: 'BEAUTY_SALON',
    /** Makeup studio category */
    MAKEUP_STUDIO: 'MAKEUP_STUDIO',
    /** Full Service Salon */
    FULL_SERVICE_SALON: 'FULL_SERVICE_SALON',
    /** Spa category */
    SPA: 'SPA',
    /** Nail salon category */
    NAIL_SALON: 'NAIL_SALON',
    /** Tattoo studio category */
    TATTOO: 'TATTOO_STUDIO',
    /** Specialized Brow Studio */
    BROW_STUDIO: 'BROW_STUDIO'
}

export const SHOP_CATEGORIES_LIST: ShopCategory[] = Object.keys(SHOP_CATEGORIES) as ShopCategory[];

export type ShopCategory = keyof typeof SHOP_CATEGORIES;

//list of poi_category values corresponding to each shop category
export const SHOP_CATEGORY_POI_MAP: Record<ShopCategory, string[]> = {
    BARBERSHOP: ['barber', 'barbershop', 'hair_cut'],
    HAIR_SALON: ['hair_salon', 'hairdresser'],
    BEAUTY_SALON: ['beauty_salon', 'cosmetics'],
    MAKEUP_STUDIO: ['makeup_studio', 'makeup_artist'],
    SPA: ['spa', 'wellness_center'],
    NAIL_SALON: ['nail_salon', 'manicure_pedicure', 'nail_studio', 'nail_bar', 'nail_care'],
    TATTOO: ['tattoo_parlor', 'tattoo_studio'],
    BROW_STUDIO: ['brow_studio', 'eyebrow_salon', 'brow_bar'],
    FULL_SERVICE_SALON: ['full_service_salon', 'salon'] //generic catch-all
} as const;
